import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import { updateProductMutation, updateProductWithAttributesMutation, insertProductMutation } from '@/store/graphql/mutations/_admin-catalog';
import { fetchCatalogItemByCatalog } from '@/store/graphql/queries/_admin-catalog';

const productManage = {
  namespaced: true,
  state: {
    catalogItems: {
      count: 0,
      data: [],
    },
  },
  actions: {
    async deleteProduct(store, product) {
      try {
        const deleteMutation = {
          mutation: updateProductMutation,
          variables: {
            itemId: product.id,
            data: {
              deleted_at: new Date().toISOString(),
            },
          },
        };

        const result = await apolloClient.mutate(deleteMutation);
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async publishProduct({ commit }, product) {
      try {
        const publishMutation = {
          mutation: updateProductMutation,
          variables: {
            itemId: product.id,
            data: {
              published_at: new Date().toISOString(),
            },
          },
        };

        const result = await apolloClient.mutate(publishMutation);
        if (result && result.data) {
          commit('catalog/SET_CURRENT_PRODUCT_VIEW', {
            productItem: result.data.update_item.returning[0],
          }, {
            root: true,
          });
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async updateProduct({ commit }, product) {
      try {
        const updateMutation = {
          mutation: updateProductWithAttributesMutation,
          variables: {
            itemId: product.id,
            data: {
              name: product.name,
              description: product.description,
              sku: product.sku,
              manufacturer: product.manufacturer,
              manufacturer_partnumber: product.manufacturer_partnumber,
              uom: product.uom,
              price: product.price,
              currency: product.currency,
              published_at: null, // Esto es momentaneo, es feo pero funciona.
              has_stock: product.has_stock,
              is_obsolete: product.is_obsolete,
              is_active: product.is_active,
              category_id: product.category_id,
              noun: product.noun,
              modifier: product.modifier,
              technical_specification: product.technical_specification,
            },
            attributes: product.item_attribute_values,
          },
        };

        const result = await apolloClient.mutate(updateMutation);
        if (result && result.data) {
          commit('catalog/SET_CURRENT_PRODUCT_VIEW', {
            productItem: result.data.update_item.returning[0],
          }, {
            root: true,
          });
        }

        return result;
      } catch (error) {
        window.console.error(error);
        throw new Error(error);
      }
    },
    async insertProduct({ commit }, product) {
      try {
        const insertMutation = {
          mutation: insertProductMutation,
          variables: {
            data: {
              name: product.name,
              description: product.description,
              sku: product.sku,
              manufacturer: product.manufacturer,
              manufacturer_partnumber: product.manufacturer_partnumber,
              uom: product.uom,
              price: product.price,
              currency: product.currency,
              has_stock: product.has_stock,
              is_obsolete: product.is_obsolete,
              is_active: product.is_active,
              catalog_id: product.catalog_id,
              category_id: product.category_id,
              noun: product.noun,
              modifier: product.modifier,
              technical_specification: product.technical_specification,
              item_attribute_values: { data: product.item_attribute_values },
            },
          },
        };

        const result = await apolloClient.mutate(insertMutation);
        if (result && result.data) {
          commit('catalog/SET_CURRENT_PRODUCT_VIEW', {
            productItem: result.data.insert_item.returning[0],
          }, {
            root: true,
          });
        }

        return result;
      } catch (error) {
        window.console.error(error);
        throw new Error(error);
      }
    },
    async searchCatalogItems({ commit, state }, filters) {
      try {
        const searchQuery = {
          fetchPolicy: 'network-only',
          query: fetchCatalogItemByCatalog,
          variables: {
            offset: filters.offset,
            limit: filters.limit,
            keyword: filters.keyword,
            catalogId: filters.catalogId,
            published_at_is_null: filters.published_at_is_null,
            price_gte: filters.price_gte,
            price_lte: filters.price_lte,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_SEARCH_CATALOG_ITEMS_RESULT', result.data);
        } else {
          throw new Error('searchCatalogItems data is null');
        }
      } catch (error) {
        window.console.error(error);
        throw new Error(error);
      }
      return state.catalogItems;
    },
  },
  mutations: {
    SET_SEARCH_CATALOG_ITEMS_RESULT(state, data) {
      Vue.set(state.catalogItems, 'data', [{ items: data.search_item }]);
      Vue.set(state.catalogItems, 'count', data.search_item_aggregate.aggregate.count);
    },
  },
};

export default productManage;



// WEBPACK FOOTER //
// ./src/store/modules/supplier/_admin-product-manage.js